<script setup>
defineProps({
  /**
   * Additional CSS classes to apply to the widget
   */
  widgetClass: {
    type: [String, Array, Object],
    default: '',
  },
  /**
   * If true, widget will be shown as empty card with plus icon
   */
  isEmptyCard: {
    type: Boolean,
    default: false,
  },
  /**
   * Title for the card
   */
  title: {
    type: String,
  },
});
</script>

<template>
  <div
      v-bind="$attrs"
      :class="['en-widget', widgetClass, { 'en-widget--empty': isEmptyCard }]">
    <div v-if="title" class="px-[0.5rem] py-[1rem] text-[1.25rem] font-weight-medium">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
@use 'Styles/helper/variables.scss';

@mixin en-widget-shared {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: variables.$en-0;
  border: 1px solid variables.$dashboard-recently-view-border;
  border-radius: 12px;
  box-shadow: 0px 3px 7px 0px rgba(13, 48, 72, 0.05) !important;
}

.en-widget {
  @include en-widget-shared;
  padding: 1rem;

  :deep(.en-widget-nested) {
    @include en-widget-shared;
  }

  &--empty {
    border: 2px dashed variables.$dashboard-recently-view-border;
    background-color: variables.$en-0;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(variables.$en-red, 0.05);
      border-color: variables.$en-red;
    }
  }
}
</style>
